import React, { useState, useEffect } from 'react';
import { onAuthStateChanged, sendEmailVerification } from 'firebase/auth';
import { auth } from '../firebase';
import { useNavigate } from 'react-router-dom';

const VerifyEmail = () => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [resending, setResending] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (!user) {
        navigate('/signin');
        return;
      }
      
      setUser(user);
      setLoading(false);
      
      // Continuously check verification status
      const checkVerification = setInterval(async () => {
        try {
          await user.reload();
          if (user.emailVerified) {
            clearInterval(checkVerification);
            navigate('/dashboard');
          }
        } catch (error) {
          console.error('Error checking verification:', error);
        }
      }, 3000); // Check every 3 seconds

      return () => clearInterval(checkVerification);
    });

    return unsubscribe;
  }, [navigate]);

  const handleResendVerification = async () => {
    if (!user) return;
    
    setResending(true);
    try {
      await sendEmailVerification(user);
      alert('Verification email sent! Check your inbox or spam folder.');
    } catch (error) {
      alert('Failed to send verification email.');
    }
    setResending(false);
  };

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[#9a51a0]"></div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <div className="max-w-md w-full bg-white rounded-2xl shadow-xl p-8 text-center">
        <div className="mb-6">
          <div className="mx-auto w-16 h-16 bg-yellow-100 rounded-full flex items-center justify-center mb-4">
            <svg className="w-8 h-8 text-yellow-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
            </svg>
          </div>
          <h2 className="text-2xl font-bold text-gray-900 mb-2">Please Verify Your Email</h2>
          <p className="text-gray-600 mb-4">
            We've sent a verification link to <strong>{user?.email}</strong>
          </p>
          <p className="text-sm text-gray-500">
            Click the verification link in your email to continue. This page will automatically redirect once verified.
          </p>
        </div>

        <div className="space-y-3">
          <button
            onClick={handleResendVerification}
            disabled={resending}
            className="w-full py-3 bg-gradient-to-r from-[#9a51a0] to-[#f36f21] text-white rounded-lg font-medium hover:opacity-90 disabled:opacity-50"
          >
            {resending ? 'Sending...' : 'Resend verification email'}
          </button>

          <button
            onClick={() => auth.signOut()}
            className="w-full py-2 text-sm text-gray-500 hover:text-gray-700"
          >
            Sign out
          </button>
        </div>
      </div>
    </div>
  );
};

export default VerifyEmail;